var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 100 100",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m95.3380508 2.5c-1.4323578 0-4.0682068.2736628-7.9152985.8109586-3.8465958.5392947-6.3334045 1.0612466-7.4548264 1.555176-1.1253204.4939122-3.1576462 2.2079616-6.0931702 5.1226349-2.9380797 2.925438-7.1998747 8.3238545-12.7724112 16.1918335-5.5812454 7.8766937-10.786068 16.1911507-15.625061 24.9502068-4.8410454 8.7623024-9.3589783 17.8591652-13.5519142 27.2893944-3.8792248-6.6411438-7.3847637-11.1438675-10.5336933-13.512619-3.1410732-2.3774643-5.7909012-3.5634613-7.9453831-3.5634613-1.6826611 0-3.7905445.8970566-6.3334084 2.6831436-2.5396171 1.7913895-3.8098538 3.544838-3.8098538 5.2742004 0 1.2514725 1.1653731 3.1063843 3.4961383 5.5592041 4.6161819 4.8770981 8.7023258 10.0491104 12.238451 15.5242538 2.1599483 3.2745209 3.5962658 5.2835922 4.3123779 6.0164413.7121798.725525 2.8820387 1.0986329 6.5109392 1.0986329 5.0479679 0 8.0461941-.647438 8.9999828-1.9496002.9451027-1.2534714 2.6939087-4.9905548 5.2448044-11.2205887 6.3028221-15.5977249 14.1393623-30.4931755 23.5063667-44.6752548 9.3750381-14.1760979 17.9616928-24.9006538 25.778923-32.1659775 1.5571747-1.3802919 2.4929733-2.2746 2.8220596-2.6877599.3203812-.4144926.4838943-.8316507.4838943-1.2661691-.0006636-.6854727-.4545439-1.0345568-1.3589323-1.0345568z",
    fill: "#FFA500",
    fillOpacity: 0.4,
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckOrange);
export default __webpack_public_path__ + "static/media/check_orange.ca2162ee4309164f651ea27bea1404a6.svg";
export { ForwardRef as ReactComponent };